import { Button, Modal } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import DeleteIcon from 'src/shared/assets/icons/cross.svg';
import CancelIcon from 'src/shared/assets/icons/round-arrow-left.svg';
import DeleteImg from 'src/shared/assets/img/delete.svg';

import styles from './confirm-delete-geo-task-modal.module.scss';

type Props = {
  isModalOpened: boolean;
  onApply: VoidFunction;
  onCancel: VoidFunction;
};

export const ConfirmDeleteGeoTaskModal = observer<Props>(function ConfirmDeleteGeoTaskModal({
  isModalOpened,
  onCancel,
  onApply,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={isModalOpened} className={styles.modal} onClickOutside={null}>
      <div className={styles.wrapper}>
        <DeleteImg className={styles.image} />
        <h2 className={styles.title}>Удалить данные?</h2>

        {/* TODO Добавить перевод */}
        <p className={styles.descriptionParagraph}>Текущее геозадание будет удалено, продолжить?</p>

        <div className={styles.buttonsWrapper}>
          <Button
            variant="primary"
            className={styles.button}
            iconPosition="before"
            icon={<DeleteIcon />}
            onClick={onCancel}
          >
            {t('common:Buttons.cancel')}
          </Button>

          <Button
            variant="danger"
            className={styles.button}
            iconPosition="before"
            icon={<CancelIcon />}
            onClick={onApply}
          >
            {t('common:Buttons.delete')}
          </Button>
        </div>
      </div>
    </Modal>
  );
});
